export default {
  button: 'login',
  signin: {
    title: 'Sign in to continue',
    or: 'or',
    signWith: 'Sign in with {{provider}}',
    consent:
      'By registering, you create a VerticalTopo account, you accept the <tou>Terms and Conditions</tou> ' +
      'and the VerticalTopo\'s <pp>Privacy Policy</pp>.',
    helper: "To create a new account or to sign in, enter your email address.\nWe'll send you an email to confirm your address.",
    form: {
      email: 'email address',
      submit: 'send confirmation email',
    },
  },
  wait: {
    title: 'Check your emails',
    info: "Don't forget to check the SPAM folder, sometimes email providers block our emails by mistake.",
    helper: 'We sent an email with a magic link to "{{email}}".\nClick on the link to confirm the address.',
    totp: 'You can also enter below, the 6-digit code that was in the email.',
    no_received: 'Did not received the email?',
    form: {
      retry: 'retry',
      submit: 'continue',
    },
  },
  settings: {
    profile: 'my profile',
    logout: 'logout',
  },
}
